var map = {
	"./games-1.mp4": "f53a",
	"./games-10.mp4": "2d06",
	"./games-11.mp4": "049c",
	"./games-12.mp4": "ffc2",
	"./games-13.mp4": "c4a9",
	"./games-14.mp4": "86a7",
	"./games-15.mp4": "ad46",
	"./games-16.mp4": "7bd72",
	"./games-17.mp4": "c76d",
	"./games-18.mp4": "ef96",
	"./games-19.mp4": "c652",
	"./games-2.mp4": "6688",
	"./games-20.mp4": "c718",
	"./games-21.mp4": "5c43",
	"./games-22.mp4": "cbf5",
	"./games-23.mp4": "5725",
	"./games-24.mp4": "7cfe",
	"./games-3.mp4": "0751",
	"./games-4.mp4": "1020",
	"./games-5.mp4": "b432",
	"./games-6.mp4": "485a7",
	"./games-7.mp4": "dcee",
	"./games-8.mp4": "0130",
	"./games-9.mp4": "7934"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a9";